import { DataSource } from "@angular/cdk/collections";
import { ClaimItReferral } from "../models/claim-it-referral.model";
import { OpportunityService } from "../services/opportunity.service";
import { concatMap, EMPTY, map, mergeWith, Observable, Subject, takeUntil, tap, timer } from "rxjs";
import { Page } from "../models/page.model";

export class PurchasedReferralDatasource extends DataSource<ClaimItReferral> {
  private onDestroy$: Subject<void> = new Subject();
  private onChange$: Subject<void> = new Subject();
  private readonly timerInterval: number = -1;
  public sortField: string | null = null;
  public sortOrder: string | null = null;
  public pageNumber: number = 0;
  public pageSize: number = 10;
  public username: string | null;
  public totalEntries: number = 0;
  public numberOfElements: number = 0;

  constructor(
    private opportunityService: OpportunityService,
    sortField: string | null,
    sortOrder: string | null,
    pageNumber: number,
    pageSize: number,
    username: string | null,
    timerInterval?: number | undefined
  ) {
    super();
    this.sortField = sortField;
    this.sortOrder = sortOrder;
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;
    this.username = username;
    this.timerInterval = timerInterval != null ? timerInterval : -1;
  }

  connect(): Observable<ClaimItReferral[]> {
    if (this.username != null) {
      return timer(0, this.timerInterval).pipe(
        mergeWith(this.onChange$),
        takeUntil(this.onDestroy$),
        concatMap(
          (): Observable<ClaimItReferral[]> =>
            this.opportunityService
              .getAcquiredReferrals(
                this.sortField,
                this.sortOrder,
                this.pageNumber,
                this.pageSize,
                this.username!
              )
              .pipe(
                tap((page: Page<ClaimItReferral>): void => {
                  this.totalEntries = page.page.totalElements;
                  this.numberOfElements =
                    page.page.totalPages == 0 || page.page.number + 1 == page.page.totalPages
                      ? page.page.totalElements - page.page.size * page.page.number
                      : page.page.size;
                }),
                map((page: Page<ClaimItReferral>): ClaimItReferral[] => page.content)
              )
        )
      );
    }
    return EMPTY;
  }

  disconnect(): void {
    if (this.timerInterval >= 0) {
      this.onDestroy$.next();
    }
  }

  sort(sortField: any): void {
    if (this.sortField === sortField) {
      if (this.sortOrder === "desc") {
        this.sortOrder = "asc";
      } else if (this.sortOrder === "asc") {
        this.sortOrder = "";
      } else {
        this.sortOrder = "desc";
      }
    } else {
      this.sortField = sortField;
      this.sortOrder = "desc";
    }
    this.onChange$.next();
  }

  updatePage(nextPage: number): void {
    if (
      (this.pageNumber + nextPage) * this.pageSize < this.totalEntries &&
      (this.pageNumber + nextPage) * this.pageSize >= 0
    ) {
      this.pageNumber += nextPage;
      this.onChange$.next();
    }
  }
}
